var Theme = Theme || {};

Theme.InstitutionSignIn = (function ($) {
    var $instLoginForm = $('.js-inst-login-form');

    return {
        init: _init
    };

    function _init() {
        loginInstitutionalUserClick();
    }

    function _loginInstitutionalUser() {
        resetErrors();
        let recaptchaResponse = SCM.Captcha.GetCaptchaResponse($instLoginForm);
        let username = $instLoginForm.find('input.js-username').val();
        let password = $instLoginForm.find('input.js-password').val();
        let ajaxUrl = '/SignIn/LoginInstitutionalUser';
        let ajaxData = {
            username: username,
            password: password,
            recaptchaResponse: recaptchaResponse,
            captchaInstanceName: SCM.Captcha.GetCaptchaInfo().ReCaptchaWidgetControlId
        };

        SCM.Ajax.post(ajaxUrl, ajaxData)
            .then(_handleAjaxResult)
            .catch(console.error);

        function _handleAjaxResult(ajaxResult) {
            if (ajaxResult.length > 0) {
                var $err = $instLoginForm.find('.js-error');
                $err.empty().removeAttr('role').removeClass('hide');
                setTimeout(function () { $err.attr('role', 'alert').text(ajaxResult); }, 100);
                SCM.Captcha.ResetCaptcha($instLoginForm);
            } else {
                let urlParams = new URLSearchParams(document.location.search);
                let returnUrl = urlParams.get('returnUrl');
                if (returnUrl) {
                    window.location.assign(decodeURIComponent(returnUrl));
                }
                else {
                    window.location.reload();
                }
            }
        }
    }
    
    function resetErrors() {
        let $errorMsg = $instLoginForm.find('.js-error');
        if(!$errorMsg.hasClass('hide')){
            $errorMsg.addClass('hide');
        }

        $errorMsg.removeAttr('role').text('');
    }
    function loginInstitutionalUserClick() {
        $instLoginForm.find('.js-signin-button').on('click', function () {
            _loginInstitutionalUser();
        });
        $instLoginForm.on('keypress', function (e) {
            if (e.key === 'Enter') {
                _loginInstitutionalUser();
            }
        });
    }

})(jQuery);